import React from 'react';
import './MobileSearch.style.css';
import { Flex, Input, Spin } from 'antd';
import SearchIcon from 'assets/icon/search_icon.svg';
import SearchIconGray from 'assets/icon/search_icon_gray.svg';
import XIcon from 'assets/icon/x_icon_666.svg';
import { useGetSearchWords } from 'hooks/SearchWordHooks';
import MessageAlert from 'utils';
import { useNavigate } from 'react-router-dom';
import { handleSearchKeyword } from 'utils/SearchKeyword';

const MobileSearch = ({ setIsSearchOpen }) => {
  /* ===== Route ===== */
  const navigate = useNavigate();

  /* ===== State ===== */
  const [searchValue, setSearchValue] = React.useState('');
  const [keywordList, setKeywordList] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== Data ===== */
  const { data: SearchWord } = useGetSearchWords(
    {
      is_show: 'Y',
    },
    {
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) {
          return [];
        }

        return data;
      },
      initialData: [],
    }
  );

  /**
   * 라우팅
   * --
   * @param {string} path
   * @param {boolean} auth
   * @returns
   */
  const handleNavigate = (path = '', auth = false) => {
    navigate(path);
  };

  /**
   * 검색 라우팅 처리
   */
  const handleSearch = () => {
    if (!searchValue) {
      MessageAlert.info('검색어를 입력해주세요!');

      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      setIsSearchOpen(false);
      handleNavigate(`/products?keyword=${encodeURIComponent(searchValue)}`);
    }, 1000);
  };

  /**
   * 추천 검색어 필터
   * --
   */
  React.useEffect(() => {
    if (SearchWord && SearchWord.length > 0) {
      setKeywordList(SearchWord);
    }
  }, [SearchWord]);
  /* React.useEffect(() => {
    if (!searchValue || !SearchWord.length) {
      setIsLoading(false);
      // setIsFocus(false);
      return;
    }

    setIsLoading(true);

    const filterWord = handleSearchKeyword(
      SearchWord,
      searchValue,
      'search_word'
    )?.sort((a, b) => a?.order - b?.order);

    console.log('filterWord ===>', filterWord);

    setTimeout(() => {
      setKeywordList([...filterWord]);
      setIsLoading(false);
    }, 500);
  }, [searchValue, SearchWord]); */

  return (
    <Spin spinning={isLoading}>
      <div className={`mobile_search`}>
        <div className="inner">
          <Flex
            gap={4}
            style={{
              borderBottom: '1px solid #7a7a7a',
              paddingBottom: 4,
            }}
          >
            <Input
              variant="borderless"
              allowClear
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              // onCompositionStart={() => setIsComposing(true)}
              // onCompositionEnd={() => setIsComposing(false)}
              onPressEnter={handleSearch}
            />
            <img
              className="search_icon"
              src={SearchIcon}
              alt="검색"
              onClick={() => handleSearch()}
            />
          </Flex>

          {/* <div className="button_wrap">
          <p>최근검색어</p>
          <button onClick={handleClearAll}>전체삭제</button>
        </div> */}

          <ul className="search_details">
            <li className="title">추천 검색어</li>
            {
              // searchValue && !isLoading
              //   ?
              keywordList?.map((_item, index) => (
                <li
                  key={`word-${index}`}
                  onClick={() => setSearchValue(_item?.search_word)}
                >
                  <div>
                    <img
                      className="details_icon"
                      src={SearchIconGray}
                      alt="검색내역"
                      width={20}
                    />
                    {_item?.search_word}
                  </div>
                  <p style={{ fontSize: 20, color: '#999', fontWeight: 300 }}>
                    ↖︎
                  </p>
                </li>
              ))
              // : null
            }
          </ul>
        </div>
      </div>
    </Spin>
  );
};

export default MobileSearch;
